const SavedViewIcon = ({ darkMode }) => {
  return (
    <svg
      width="15"
      height="19"
      viewBox="0 0 15 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${darkMode ? 'text-white' : 'text-[#27292C]'} mr-4 h-6`}
    >
      <path
        d="M12.7744 15.3986L7.77441 13.2186L2.77441 15.3986V2.39856H12.7744M12.7744 0.39856H2.77441C2.24398 0.39856 1.73527 0.609273 1.3602 0.984346C0.985128 1.35942 0.774414 1.86813 0.774414 2.39856V18.3986L7.77441 15.3986L14.7744 18.3986V2.39856C14.7744 1.28856 13.8744 0.39856 12.7744 0.39856Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SavedViewIcon
